import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70b12e66&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b12e66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b12e66')) {
      api.createRecord('70b12e66', component.options)
    } else {
      api.reload('70b12e66', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70b12e66&scoped=true", function () {
      api.rerender('70b12e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/index.vue"
export default component.exports